import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Outlet } from 'react-router-dom'
import Header from '../components/header/Header'

import MainMenu from '../components/menu/Main'
import Footer from '../components/footer/footer'

export default function MainLayout() {
    return (
        <>
            <Container>
                <Row><Header /></Row>
                <Row><MainMenu /></Row>
            </Container>

            <Container fluid className='only-border'></Container>

            <Container className='m-t-10 p-0'>
                <Outlet />
            </Container>


            {/* <div style={{ position: 'absolute', bottom: 328, right: 0, left: 0, }} className='only-border'></div> */}

            {/* <Container fluid className='only-border'></Container> */}

            <Container className='m-t-20'>
                <Footer />
            </Container>
        </>

    )
}
